import * as React from "react";
import { batchActions } from "redux-batched-actions";

import { ClanEditDialogsContainer, ClanLeaveDialogContainer, RecommendationsClanSettingsDialog, ChangeRoleOperationDialogContainer } from "../../Containers/";

import { RulesDialog, ClanDescriptionDialog, RemoveMembersOperationDialog, ChangeCommanderOperationDialog } from "UIKit";

import { Tooltip } from "components";

import { toggleMembersSorting, changeClanBattleType, changeClanTeamNumber, fetchMembers, fetchClan, toggleMemberTick, toggleAllMembersTick, removeMembers, changeCommander, setClanProfileCurrentSeason } from "../../Actions/ActionClanProfile";

import { showDialog, hideDialog } from "../../Actions/ActionDialog";
import { introductionIsShown } from "../../Actions/ActionIntroduction";

import { openAccountProfile, openChatWindow } from "web2ClientAPI/web2ClientAPI";
import { showSendApplicationDialog, showAcceptInviteDialog } from "helpers/dialog";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClanDescriptionClick: rawDescription => {
      Tooltip.manager.destroyActiveTooltip();
      const content = <ClanDescriptionDialog rawDescription={rawDescription} hideDialog={() => dispatch(hideDialog())} />;
      dispatch(showDialog(content, 'large'));
    },
    onThSortClick: (field, isAsc, hiddenSortingNames, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(toggleMembersSorting(currentClanId, field, isAsc, hiddenSortingNames));
    },
    onBattleTypeChange: (selectedBattleType, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(changeClanBattleType(currentClanId, selectedBattleType));
      dispatch(fetchMembers(currentClanId));
    },
    onTeamNumberChange: (selectedTeamNumber, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(changeClanTeamNumber(currentClanId, selectedTeamNumber));
      dispatch(fetchMembers(currentClanId));
    },
    onMembersReloadClick: clanId => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(fetchMembers(currentClanId));
    },
    onRender: clanId => {
      dispatch(fetchClan(clanId));
      dispatch(fetchMembers(clanId, true));
    },
    onClanReloadClick: () => {
      dispatch(fetchClan(ownProps.clanId, false));
      dispatch(fetchMembers(ownProps.clanId));
    },
    onTickMember: member => {
      dispatch(toggleMemberTick(member));
    },
    onTickAllMembers: members => {
      dispatch(toggleAllMembersTick(members));
    },
    onRemoveMembersClick: membersToRemove => {
      const removeDialog = <RemoveMembersOperationDialog membersToRemove={membersToRemove} onCloseClick={() => {
        dispatch(hideDialog());
      }} onRemoveClick={() => {
        return dispatch(removeMembers(membersToRemove.map(m => m.id))).then(() => {
          dispatch(hideDialog());
        });
      }} />;
      dispatch(showDialog(removeDialog, 'small'));
    },
    onChangeCommanderClick: newCommander => {
      const changeCommanderDialog = <ChangeCommanderOperationDialog newCommander={newCommander} onCloseClick={() => {
        dispatch(hideDialog());
      }} onChangeClick={() => {
        return dispatch(changeCommander(newCommander.id)).then(isSuccess => {
          isSuccess && dispatch(hideDialog());
        });
      }} />;
      dispatch(showDialog(changeCommanderDialog, 'small'));
    },
    onChangeRoleClick: memberToChangeId => {
      dispatch(showDialog(<ChangeRoleOperationDialogContainer memberToChangeId={memberToChangeId} />, 'small'));
    },
    onDescriptionEditClick: () => dispatch(showDialog(<ClanEditDialogsContainer dialogType="clanDescription" />, 'large')),
    onRecommendationsClanSettingsClick: () => dispatch(showDialog(<RecommendationsClanSettingsDialog />, 'large')),
    onNameEditClick: () => dispatch(showDialog(<ClanEditDialogsContainer dialogType="clanName" />, 'large')),
    onLeaveClick: () => dispatch(showDialog(<ClanLeaveDialogContainer />, 'small')),

    onRulesDialogClick: content => dispatch(showDialog(<RulesDialog data={content} onCloseClick={() => dispatch(hideDialog())} />, 'large')),

    onSendApplication: clan => {
      const sourceQuery = ownProps.routeQuery ? ownProps.routeQuery.source : null;
      const source = sourceQuery || (ownProps.source || 'profile');

      dispatch(showSendApplicationDialog(clan, source));
    },
    onAcceptInvite: invite => {
      dispatch(hideDialog());
      dispatch(showAcceptInviteDialog(invite));
    },
    onSeasonChange: (season, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(setClanProfileCurrentSeason(season));
      dispatch(fetchMembers(currentClanId));
    },
    openAccountProfile,
    openChatWindow
  };
};

export default mapDispatchToProps;